import React, { useEffect, useRef } from "react";
import { graphql, useStaticQuery } from "gatsby";
import { eventuallyInsertReevooScript } from "../../utility/reevoo";

const ReevooBadge = ({ productId }) => {
  const containerRef = useRef();

  const { config } = useStaticQuery(
    graphql`
      {
        config: liferayGeneralConfiguration {
          isReevooActive
        }
      }
    `
  );

  useEffect(() => {
    const container = containerRef.current;
    if (container && productId && config.isReevooActive?.[0] === "yes") {
      // const badge = document.createElement("div");
      // badge.classList.add("feefo-product-stars-widget");
      // badge.setAttribute("data-product-sku", productId);
      // container.appendChild(badge);
      eventuallyInsertReevooScript();
    }
  }, [productId, config]);

  return (
    <div ref={containerRef}>
      <div className="feefo-product-stars-widget" data-product-sku={productId}></div>
    </div>
  );
};

export default React.memo(ReevooBadge);
